import { FIN_FRACTION_DIGITS, FIN_FRACTION_DIGITS_ROUNDING } from '../config'

export const getFractionDigits = (rounding?: string) => {
  let digits = FIN_FRACTION_DIGITS

  if (rounding) {
    switch (rounding) {
      case 'K': {
        digits = FIN_FRACTION_DIGITS_ROUNDING
        break
      }
      case 'M': {
        digits = FIN_FRACTION_DIGITS_ROUNDING
        break
      }
      case 'AsIs':
      default: {
        break
      }
    }
  }

  return digits
}
